import { render, staticRenderFns } from "./SitePerformanceList.vue?vue&type=template&id=23219e70&scoped=true"
import script from "./SitePerformanceList.vue?vue&type=script&lang=js"
export * from "./SitePerformanceList.vue?vue&type=script&lang=js"
import style0 from "./SitePerformanceList.vue?vue&type=style&index=0&id=23219e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23219e70",
  null
  
)

export default component.exports